<template>
  <section class="page-section" v-loading="pageLoading">
    <div class="form-wrap">
      <el-form
        size="small"
        ref="formData"
        :model="formData"
        label-width="80px"
        class="content-form"
      >
        <el-form-item label="图标" required :show-message="false">
          <div class="category-pics-box margin-top-15">
            <div class="pics-box">
              <el-upload
                :action="uploadPicUrl"
                list-type="picture-card"
                :file-list="formData.icons"
                accept=".png,.jpg,.jpeg"
                drag
                :on-preview="handlePicPreview"
                :on-remove="handleIconPicRemove"
                :on-success="handleIconPicSuccess"
                :on-error="handleIconPicError"
                :before-upload="handlePicBeforeUpload"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
            </div>
            <div class="tips">支持jpg、png格式，建议尺寸：100*100像素</div>
          </div>
        </el-form-item>
        <el-form-item label="关键词" required :show-message="false">
          <el-input
            v-model="formData.keyword"
            maxlength="4"
            placeholder="2-4个中文字符"
            class="w150"
            @blur="handleValidKeyword"
          ></el-input>
        </el-form-item>
        <el-form-item label="标题" required :show-message="false">
          <div>
            <el-input
              v-model="formData.title"
              class="w150"
              @blur="handleValidTitle"
            ></el-input>
            <el-checkbox
              v-model="formData.adStatus"
              class="margin-left-20"
              false-label="0"
              true-label="1"
              >启用广告位</el-checkbox
            >
          </div>
          <div
            class="category-pics-box margin-top-15"
            v-if="formData.adStatus == '1'"
          >
            <div class="pics-box">
              <el-upload
                :action="uploadPicUrl"
                list-type="picture-card"
                :file-list="formData.pics"
                accept=".png,.jpg,.jpeg"
                drag
                :on-preview="handlePicPreview"
                :on-remove="handleBannerPicRemove"
                :on-success="handleBannerPicSuccess"
                :on-error="handleBannerPicError"
                :before-upload="handlePicBeforeUpload"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
            </div>
            <div class="tips">支持jpg、png格式，建议尺寸：690*200像素</div>
          </div>
        </el-form-item>
        <el-form-item label="关联商品" required :show-message="false">
          <div class="flex-h">
            <div class="flex-a-i">
              <el-button
                type="text"
                size="small"
                style="margin-left: 0"
                @click="handleRelatedGoodsDialogShow"
                >关联商品</el-button
              >
            </div>
            <div v-if="commodityList.page.total > 0">
              <el-pagination
                small
                @current-change="handleCommodityListPageChange"
                :current-page="commodityList.page.current"
                :page-size="commodityList.page.size"
                layout="total, prev, pager, next"
                :total="commodityList.page.total"
              >
              </el-pagination>
            </div>
          </div>

          <el-table
            size="small"
            :data="commodityList.tableData"
            v-loading="commodityList.tableLoading"
            v-if="commodityList.tableData.length > 0"
          >
            <el-table-column label="商品" width="400">
              <template slot-scope="scope">
                <div class="dialog-goods-title">
                  <div class="thumb-wrap">
                    <img
                      :src="scope.row.mainPic"
                      style="pointer-events: none"
                    />
                  </div>
                  <p>{{ scope.row.name }}</p>
                  <p>¥{{ scope.row.price }}</p>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="商品类目">
              <template slot-scope="scope">
                <p v-for="(item, index) in scope.row.category" :key="index">
                  {{ item }}
                </p>
              </template>
            </el-table-column>
            <el-table-column label="库存" width="80">
              <template slot-scope="scope">
                <p>{{ scope.row.stock }}</p>
              </template>
            </el-table-column>
            <el-table-column label="总销量" width="60">
              <template slot-scope="scope">
                <p>{{ scope.row.sale || "-" }}</p>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="right">
              <template slot-scope="scope">
                <el-button
                  size="small"
                  type="text"
                  @click="handleCommodityListRowRemove(scope.row, scope.$index)"
                  >移除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="时间设置">
          <el-date-picker
            v-model="formData.time"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            align="right"
            class="w370"
          ></el-date-picker>
        </el-form-item>

        <div class="margin-top-15">
          <el-button
            type="primary"
            size="small"
            :loading="submitLoading"
            @click="handleSave"
            >保存</el-button
          >
          <el-button
            type="default"
            size="small"
            plain
            @click="pageLinkToComponentList"
            >取消</el-button
          >
        </div>
      </el-form>
    </div>
  

  <!-- 关联商品 弹窗 -->
  <DialogGoods
    :ids="commodityList.ids"
    ref="goodsRelate"
    @ids="getRelatedGoodsIds"
  ></DialogGoods>

  <!-- 图片预览 -->
  <el-dialog
    :visible.sync="previewDialogShow"
    custom-class="preview-image-dialog"
  >
    <img width="100%" :src="previewDialogImageUrl" alt="" />
  </el-dialog>
      </section>
</template>

<script>
import {
  COMMON,
  uploadPath,
  moduleActivitySave,
  moduleActivityDetail,
  moduleCommodityList,
  moduleCommodityDelete,
  moduleSelectCommodityList,
  validShopProps,
  commodityFilterList,
} from "@/common/api";
import DialogGoods from "@/components/dialog/goods.vue";

export default {
  name: "shopComponentActivityAdd",
  components: {
    DialogGoods,
  },
  data() {
    return {
      id: this.$route.query.id || "",

      pageLoading: false, // 页面loading

      commodityList: [], // 商品列表

      formData: {
        icons: [],
        keyword: "",
        title: "",
        adStatus: "0",
        pics: [],
        commodityIds: [],
        time: [],
      },
      submitLoading: false,

      uploadPicUrl: uploadPath + "/module/uploadPic", // 图片上传地址
      previewDialogShow: false, // 预览图片 - 弹窗
      previewDialogImageUrl: "", // 预览图片 - url

      commodityList: {
        // 选中的指定商品
        ids: [],
        tableLoading: false,
        tableData: [],
        page: {
          current: 1,
          size: 9999,
          total: 0,
        },
      },
    };
  },
  methods: {
    /**
     * [handleValidTitle description] 校验组件标题是否重复
     * @return {[type]} [description]
     */
    handleValidTitle: function () {
      let params = {
        id: this.id,
        type: 0,
        name: this.formData.title,
      };

      validShopProps(params).then((res) => {
        let { code, data, msg } = res;

        if (code != 0) {
          this.$message.error(msg);
        }
      });
    },
    /**
     * [handleValidKeyword description] 校验组件关键词是否重复
     * @return {[type]} [description]
     */
    handleValidKeyword: function () {
      let params = {
        id: this.id,
        type: 1,
        name: this.formData.keyword,
      };

      validShopProps(params).then((res) => {
        let { code, data, msg } = res;

        if (code != 0) {
          this.$message.error(msg);
        }
      });
    },
    /**
     * [getDetail description] 获取详情
     * @param  {[type]} val [description]
     * @return {[type]}     [description]
     */
    getDetail: function () {
      if (!this.id) {
        this.pageLoading = false;
        return false;
      }

      this.pageLoading = true;

      let params = {
        id: this.id,
      };

      moduleActivityDetail(params)
        .then((res) => {
          this.pageLoading = false;

          let { code, data, msg } = res;

          if (code == 0) {
            this.formData.icons = [
              {
                name: data.iconPath,
                percentage: 100,
                status: "success",
                url: data.iconPath,
                response: {
                  data: {
                    url: data.icon,
                    path: data.iconPath,
                  },
                },
              },
            ];
            this.formData.keyword = data.keyWord;
            this.formData.title = data.title;
            this.formData.adStatus = "" + data.adStatus;
            this.formData.pics = [
              {
                name: data.picPath,
                percentage: 100,
                status: "success",
                url: data.picPath,
                response: {
                  data: {
                    url: data.picUrl,
                    path: data.picPath,
                  },
                },
              },
            ];

            this.formData.commodityIds = data.commodity;
            this.handleGetRelatedGoodsList();

            if (data.startTime && data.endTime) {
              this.formData.time = [data.startTime, data.endTime];
            }
          } else {
            this.$message.error(msg);
          }
        })
        .catch((error) => {
          this.$message.error("服务器异常");
        });
    },
    // ==============================================================================================================================
    /**
     * [handleRelatedGoodsDialogShow description] 指定商品 - 弹窗 - 显示
     * @return {[type]} [description]
     */
    handleRelatedGoodsDialogShow: function () {
      this.commodityList.ids = JSON.parse(
        JSON.stringify(this.formData.commodityIds),
      );
      this.$refs.goodsRelate.handleDialogShow();
    },
    /**
     * [getRelatedGoodsIds description] 指定商品 - 弹窗 - 选中的数据id集合
     * @param  {[type]} ids [description]
     * @return {[type]}     [description]
     */
    getRelatedGoodsIds: function (ids) {
      this.formData.commodityIds = ids;
      this.handleGetRelatedGoodsList();
    },
    /**
     * [handleGetRelatedGoodsList description] 指定商品 - 根据选中数据的id集合获取商品列表
     * @return {[type]} [description]
     */
    handleGetRelatedGoodsList: function () {
      this.commodityList.tableLoading = true;

      let params = {
        idStr: this.formData.commodityIds.join(","),
        current: this.commodityList.page.current,
        size: this.commodityList.page.size,
      };

      commodityFilterList(params)
        .then((res) => {
          this.commodityList.tableLoading = false;

          let { code, data, msg } = res;

          if (code == 0) {
            let dataArray = data.records || [];

            this.commodityList.tableData = dataArray;
            this.commodityList.page.total = data.total;

            this.$nextTick(() => {
              this.handleTableRowSort();
            });
          } else {
            this.$message.error(msg);
          }
        })
        .catch((error) => {
          this.$message.error("服务器异常");
        });
    },
    /**
     * [handleCommodityListPageChange description] 指定商品 - 列表 - 切换分页
     * @param  {[type]} val [description]
     * @return {[type]}     [description]
     */
    handleCommodityListPageChange: function (val) {
      this.commodityList.page.current = val;
      this.handleGetRelatedGoodsList();
    },
    /**
     * [handleCommodityListRowRemove description] 指定商品 - 列表 - 移除
     * @param  {[type]} row   [description]
     * @param  {[type]} index [description]
     * @return {[type]}       [description]
     */
    handleCommodityListRowRemove: function (row, index) {
      let tableData = this.commodityList.tableData,
        ids = this.formData.commodityIds;

      tableData.splice(index, 1);
      ids.splice(ids.indexOf(row.id), 1);
      this.commodityList.page.total -= 1;
    },

    // ==============================================================================================================================
    /**
     * [handleSave description] 保存
     * @return {[type]} [description]
     */
    handleSave: function () {
      if (this.formData.icons.length == 0) {
        this.$message.error("请上传图标");
        return false;
      }

      if (!this.formData.keyword) {
        this.$message.error("请输入关键词");
        return false;
      }
      if (
        this.formData.keyword.length < 2 ||
        this.formData.keyword.length > 4
      ) {
        this.$message.error("关键词请输入2-4个中文字符");
        return false;
      }

      if (!this.formData.title) {
        this.$message.error("请输入标题");
        return false;
      }

      if (this.formData.adStatus == "1" && this.formData.pics.length == 0) {
        this.$message.error("请上传广告图片");
        return false;
      }

      if (this.formData.commodityIds.length == 0) {
        this.$message.error("请关联商品");
        return false;
      }

      this.submitLoading = true;

      let params = {
        id: this.id,
        icon: this.formData.icons[0].response.data.url,
        keyWord: this.formData.keyword,
        title: this.formData.title,
        adStatus: this.formData.adStatus,
        picUrl:
          this.formData.adStatus == "1"
            ? this.formData.pics[0].response.data.url
            : "",
        commodity: this.formData.commodityIds.join(","),
        startTime:
          this.formData.time && this.formData.time.length > 0
            ? COMMON.formatDate(2, "/", this.formData.time[0])
            : "",
        endTime:
          this.formData.time && this.formData.time.length > 0
            ? COMMON.formatDate(2, "/", this.formData.time[1])
            : "",
      };

      moduleActivitySave(params)
        .then((res) => {
          this.submitLoading = false;

          let { code, data, msg } = res;

          if (code == 0) {
            this.$message({ message: "保存成功", type: "success" });

            this.$router.push({
              path: "/shop/component/list",
              query: { name: "1" },
            });
          } else {
            this.$message.error(msg);
          }
        })
        .catch((error) => {
          this.submitLoading = false;
          this.$message.error("服务器异常");
        });
    },
    /**
     * [pageLinkToComponentList description] 取消
     * @return {[type]} [description]
     */
    pageLinkToComponentList: function () {
      this.$router.push({ path: "/shop/component/list", query: { name: "1" } });
    },
    /**
     * [handleDetailPicturesBeforeUpload description] 图片上传之前格式校验
     * @param  {[type]} file [description]
     * @return {[type]}      [description]
     */
    handlePicBeforeUpload: function (file) {
      let fileName = file.name,
        fileNameArr = fileName.split("."),
        fileType = fileNameArr[fileNameArr.length - 1],
        supportArr = ["jpg", "jpeg", "png"];

      if (supportArr.indexOf(fileType) == -1) {
        this.$message.error("请上传jpg、jpeg、png格式的图片");
        return false;
      }
    },
    handlePicPreview: function (file) {
      this.previewDialogImageUrl = file.url;
      this.previewDialogShow = true;
    },
    // 图标
    handleIconPicSuccess: function (response, file, fileList) {
      this.formData.icons = fileList;
    },
    handleIconPicError: function (err, file, fileList) {
      this.$message.error("图片上传失败");
      this.formData.icons = fileList;
    },
    handleIconPicRemove: function (file, fileList) {
      this.formData.icons = fileList;
    },
    // banner图
    handleBannerPicSuccess: function (response, file, fileList) {
      this.formData.pics = fileList;
    },
    handleBannerPicError: function (err, file, fileList) {
      this.$message.error("图片上传失败");
    },
    handleBannerPicRemove: function (file, fileList) {
      this.formData.pics = fileList;
    },
    /**
     * [handleTableRowSort description] 给表格每一行绑定移动事件
     * @return {[type]} [description]
     */
    handleTableRowSort: function () {
      let table = document.getElementsByClassName("el-table__body"),
        tableTR;

      if (!table[0] || this.commodityList.tableData.length == 0) {
        return false;
      }

      tableTR = table[0].getElementsByTagName("tr");

      for (let i = 0; i < tableTR.length; i++) {
        tableTR[i].draggable = false;
        tableTR[i].style.cursor = "auto";
        tableTR[i].removeEventListener(
          "dragstart",
          this.handleTableTRDragStart,
        );
        tableTR[i].removeEventListener("dragover", this.handleTableTRDragover);
        tableTR[i].removeEventListener("drop", this.handleTableTRDrop);
      }

      for (let i = 0; i < tableTR.length; i++) {
        let tableTRItem = tableTR[i];

        tableTRItem.draggable = true;
        tableTRItem.setAttribute("data-index", i);
        tableTRItem.style.cursor = "all-scroll";

        tableTRItem.addEventListener(
          "dragstart",
          this.handleTableTRDragStart,
          false,
        );
        tableTRItem.addEventListener(
          "dragover",
          this.handleTableTRDragover,
          false,
        );
        tableTRItem.addEventListener("drop", this.handleTableTRDrop, false);
      }
    },
    /**
     * [handleTableTRDragStart description] 拖动开始，设置携带的参数
     * @param  {[type]} ev [description] 拖动对象
     * @return {[type]}    [description]
     */
    handleTableTRDragStart: function (ev) {
      ev.dataTransfer.setData("index", ev.target.dataset.index);
    },
    /**
     * [handleTableTRDragover description] 必须要 preventDefault, 否则不会触发 drop
     * @param  {[type]} ev [description]
     * @return {[type]}    [description]
     */
    handleTableTRDragover: function (ev) {
      ev.preventDefault();
    },
    /**
     * [handleTableTRDrop description] 拖动释放触发的方法
     * @param  {[type]} ev [description] 目标对象
     * @return {[type]}    [description]
     */
    handleTableTRDrop: function (ev) {
      ev.preventDefault();

      let originalIndex = ev.dataTransfer.getData("index"),
        trNode = this.handleGetTRNode(ev.target),
        targetIndex = trNode.getAttribute("data-index");

      if (originalIndex == targetIndex) {
        // 原地释放
        return false;
      }

      // 将移动的对象插入目标对象之前
      let originalObject = this.commodityList.tableData.splice(
          originalIndex,
          1,
        ),
        originalId = this.formData.commodityIds.splice(originalIndex, 1);
      this.commodityList.tableData.splice(targetIndex, 0, originalObject[0]);
      this.formData.commodityIds.splice(targetIndex, 0, originalId[0]);

      // do request
      this.handleGetRelatedGoodsList();
    },
    /**
     * [handleGetTRNode description] 循环查找dom父节点，直到匹配到tr
     * @param  {[type]} ob [description] 当前dom节点
     * @return {[type]}    [description]
     */
    handleGetTRNode: function (ob) {
      if (ob.tagName == "TR") {
        return ob;
      } else {
        return this.handleGetTRNode(ob.parentNode);
      }
    },
  },
  mounted() {
    this.getDetail();
  },
};
</script>
<style lang="scss" scoped>
@import "../../../common/styles/base/mixin-font";
@import "../../../common/styles/base/mixin-common";

.thumb-wrap {
  position: relative;
  display: inline-block;
  margin-right: 10px;
  vertical-align: middle;
  width: 48px;
  height: 48px;
  background-color: $colorPageBg;

  img {
    max-width: 100%;
    max-height: 100%;
    @include position(absolute, 1, 50%, none, none, 50%);
    @include translate(-50%, -50%, 0);
  }
}

.form-wrap {
  padding: 10px 35px;
  background: $colorPageBg;
}

.block-item {
  .label {
    width: 5em;
    text-align: right;

    .required-icon {
      color: #f56c6c;
    }
  }
}

.pics-box {
  ::v-deep .el-upload-list--picture-card {
    .el-upload-list__item {
      position: relative;
      width: 100px;
      height: 100px;
      border-radius: 2px;

      .el-upload-list__item-thumbnail {
        @include position(absolute, none, 50%, none, none, 50%);
        @include translate(-50%, -50%, 0);
      }

      .el-progress {
        width: 80px;
        height: 80px;

        .el-progress-circle {
          width: 80px !important;
          height: 80px !important;
        }
      }

      .el-icon-close-tip {
        display: none;
      }
    }
  }

  ::v-deep .el-upload--picture-card {
    width: 100px;
    height: 100px;
    line-height: 98px;
    border-radius: 2px;

    .el-upload-dragger {
      width: 98px;
      height: 98px;
      border: none;

      .el-icon-plus {
        font-size: $baseFS;
      }
    }
  }
}

.category-pics-box {
  .pics-box {
    width: 100px;
    height: 100px;
    overflow: hidden;
  }
}

.label-pics-box {
  .pics-box {
    width: 70px;
    height: 70px;
    overflow: hidden;

    ::v-deep .el-upload-list--picture-card {
      .el-upload-list__item {
        width: 70px;
        height: 70px;

        .el-progress {
          width: 560px;
          height: 56px;

          .el-progress-circle {
            width: 56px !important;
            height: 56px !important;
          }
        }
      }
    }

    ::v-deep .el-upload--picture-card {
      width: 70px;
      height: 70px;
      line-height: 68px;

      .el-upload-dragger {
        width: 68px;
        height: 68px;
      }
    }
  }
}
</style>
